/**
 * Created by Rodrigo Quesada on 23/03/17.
 */

export class RolesData {
    ADMIN = 'Admin';
}

export const Roles = new RolesData();



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/authorization/roles.ts